const REQUEST_SET_CENTER_MAP = 'REQUEST_SET_CENTER_MAP'
const CLEAR_CENTER_MAP = 'CLEAR_CENTER_MAP'

const requestSetCenterMap = (lat, long) => {
  return {
    type: REQUEST_SET_CENTER_MAP,
    lat,
    long,
  }
}

const setCenterMap = (lat, long) => {
  return (dispatch) => {
    dispatch(requestSetCenterMap(lat, long))
  }
}

const clearCenterMap = () => {
  return {
    type: CLEAR_CENTER_MAP,
  }
}

export {
  requestSetCenterMap,
  setCenterMap,
  REQUEST_SET_CENTER_MAP,

  clearCenterMap,
  CLEAR_CENTER_MAP,
}
